<template>
  <nav class="navbar navbar-expand-md navbar-light pt-1 ps-1 pe-3 shadow-sm">
    <div class="container-fluid">
      <ul class="navbar-nav ms-auto mb-2 mb-md-0 me-3">
        <li class="nav-item dropdown my-auto ms-5">
          <img src="@/assets/img/profilbild.png" alt="Profil Bild" class="avatar me-2" />

          <a class="nav-link dropdown-toggle d-inline pe-0" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ authStore.user?.username }}
          </a>
          <ul class="dropdown-menu m-0">
            <li>
              <button class="dropdown-item" @click="logout">
                <font-awesome-icon icon="arrow-right-from-bracket" class="me-3" />
                Abmelden
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts" setup>
  //#region Imports
  import { useAuthStore } from '@/stores/authStore';
  import { useRouter } from 'vue-router';
  //#endregion

  const authStore = useAuthStore();
  const router = useRouter();

  function logout() {
    authStore.logout().then(() => {
      router.push({ name: 'Login' });
    });
  }
</script>

<style lang="scss" scoped>
  img.avatar {
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid #770025;
    height: 45px;
    width: 45px;
  }
</style>
